import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  active: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired, // example: calc(20% + 30px)
}

const BrowserTabButton = (props) => {
  const style = {
    background: '#EEEEEE',
    maxWidth: 300,
    width: props.width,
    height: 30,
    marginRight: 10,
    float: 'left',
    padding: '9px 10px 0 10px',
    border: '1px solid #AAA',
    borderBottom: 'none',
    cursor: 'pointer',
  }
  if (props.active === true) {
    Object.assign(style, { marginTop: 1, zIndex: 100 })
  } else {
    Object.assign(style, { zIndex: 1 })
  }

  return (
    <div
      style={style}
      onClick={() => props.handleClick(props.id)}
      onKeyPress={() => props.handleClick(props.id)}
      role="button"
    >
      {props.name}
    </div>
  )
}

BrowserTabButton.propTypes = propTypes

export default BrowserTabButton
